module.exports = __webpack_public_path__ + "img/email.f7e3bead.svg";